import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import request from 'helpers/request';
import { getContentBasePath } from 'helpers/utilities';
import { heroSelector } from 'src/redux/app/selectors';

import Hero from 'components/Hero/Hero';
import BikeGrid from 'components/BikeGrid/BikeGrid';
import { setError } from 'src/redux/app/actions';

const Bikes = ({ familyId }) => {
  const [familyHero, setFamilyHero] = useState({});
  const hero = useSelector(heroSelector);
  const dispatch = useDispatch();

  const bikeButtons = [];

  useEffect(() => {
    if (familyId) {
      const fetchFamilyContent = async () => {
        try {
          const res = await request(`${getContentBasePath()}?family=${familyId}`);

          setFamilyHero(res.data.hero);
        } catch (ex) {
          dispatch(setError(ex));
        }
      };

      fetchFamilyContent();
    }
  }, [dispatch, familyId]);

  if (familyId) {
    bikeButtons.push({
      id: 'viewall',
      label: 'viewAllButton',
      to: '/bikes',
      white: true,
    });
  }

  const title = familyId ? familyHero.heroTitle : hero.title;
  const image = familyId ? familyHero.heroImage : hero.image;

  return (
    <>
      <Hero buttons={bikeButtons} title={title} image={image} hasFilters />
      <BikeGrid familyId={familyId} />
    </>
  );
};

export default Bikes;
